import * as React from "react";
import { Viewer } from "@react-pdf-viewer/core";
import { thumbnailPlugin } from "@react-pdf-viewer/thumbnail";
import { Worker } from "@react-pdf-viewer/core";

import { pageThumbnailPlugin } from "./pDFPreview";
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/thumbnail/lib/styles/index.css';

interface DisplayThumbnailProps {
  fileUrl: string;
  pageIndex: number;
}

const DisplayThumbnail: React.FC<DisplayThumbnailProps> = ({
  fileUrl,
  pageIndex,
}) => {
  const thumbnailPluginInstance = thumbnailPlugin();

  const memoizedFileUrl = React.useMemo(() => pageIndex, [pageIndex]);

  const { Cover } = thumbnailPluginInstance;
  const pageThumbnailPluginInstance = pageThumbnailPlugin({
    PageThumbnail: <Cover getPageIndex={() => memoizedFileUrl} />,
  });

  return (
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
      <div className="w-full h-full">
        <Viewer
          fileUrl={fileUrl}
          plugins={[pageThumbnailPluginInstance, thumbnailPluginInstance]}
        />
      </div>
    </Worker>
  );
};

export default DisplayThumbnail;
